import { Form, Input, Row, Col, Select, DatePicker, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react';
import AntDraggableModal from '../../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../../system/WebEditUniversalNewEx';
import fetchApi from '../../../../utils/api/fetchApi';
import getList from "../../../universal/getList";

//布局
const layout = {
    // labelCol: { span: 8 },
    // wrapperCol: { span: 16 }, 
};

const WebEdit = (props: any) => {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };

    /** 后端数据defaultService */
    let defaultService: any = '';

    const [wxSubscribeMessageV2TypeData, setWxSubscribeMessageV2TypeData] = useState<any>();
    const [wxAccountWxData, setWxAccountWxData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            defaultService = ref.current.defaultService;
            ref.current.row.then((res: any) => {
            })
        }
        const fetchData = async () => {
            fetchApi.GET(defaultService,
                {
                    apiId: 'wxSubscribeMessageV2Type',
                    apiExtend: 'showList'
                }).then(res => {
                    if (res.success) {
                        setWxSubscribeMessageV2TypeData(res.data);
                    }
                })
            fetchApi.GET(defaultService,
                {
                    apiId: 'generalData',
                    apiExtend: 'wxAccountList',
                    apiData: {
                        slectType: 'wx@wxMiniApp'
                    }
                }).then(res => {
                    if (res.success) {
                        setWxAccountWxData(res.data);
                    }
                })
        }
        fetchData();
    }, []);

    const onSelectHandle = (e: any) => {
        form.setFieldValue('typeName', e.children);
    }

    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'wxSubscribeMessageV2User',
        serviceId: 'business',
        dateColumnName: ['lastTime']
    };

    return (
        <><WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '微信订阅信息V2用户'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={700}>

                <Form
                    {...layout}
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                // onKeyPress={(e: any) => {
                //     if (e.key === 'Enter') {
                //         handleOk(e)
                //     }
                // }}
                >
                    <Row gutter={[8, 0]}>

                        <Col span={12}>
                            <Form.Item
                                label="wxOpenId"
                                name="wxOpenId"
                                rules={[{ required: true, message: 'wxOpenId"!' }]}>
                                <Input placeholder="wxOpenId" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="微信帐号"
                                name="wxAccountId"
                                rules={[{ required: true, message: '微信帐号"!' }]}>
                                <Select
                                    showSearch
                                    placeholder="微信帐号"
                                    optionFilterProp="children"
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(wxAccountWxData)}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="类型"
                                name="wxSubscribeMessageV2TypeId"
                                rules={[{ required: true, message: '类型!' }]}>
                                <Select
                                    showSearch
                                    placeholder="wxSubscribeMessageV2TypeId"
                                    optionFilterProp="children"
                                    onSelect={(_key, e) => onSelectHandle(e)}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(wxSubscribeMessageV2TypeData, {
                                        itemName: 'typeName'
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="服务id"
                                name="serviceId"
                                rules={[{ required: true, message: '服务id!' }]}>
                                <Input placeholder="serviceId" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="动态更新令牌"
                                name="notifyCode">
                                <Input placeholder="notifyCode" />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label="最后使用时间"
                                name="lastTime">
                                <DatePicker
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={20}>
                            <Form.Item
                                label="跳转"
                                name="wxa_path_query">
                                <Input placeholder="wxa_path_query" />
                            </Form.Item>
                        </Col>

                        <Col span={4}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                < Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>

                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}

export default WebEdit;